import ReactDOM from 'react-dom';
import React from 'react';
import Auth from 'App/Auth';
import { BrowserRouter } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import 'App/bootstrap';

Spin.setDefaultIndicator(<LoadingOutlined style={{ fontSize: 36 }} />);

ReactDOM.render(
  <BrowserRouter>
    <Auth />
  </BrowserRouter>,
  document.getElementById('auth')
);
